import React from 'react';
import ImageNodeForm from 'routes/surface/components/node-modal-form/components/image-node-modal/components/image-node-form';
import { useOnSurfaceNodeSave } from 'components/canvas/hooks/use-on-surface-node-save';
import useMutation from 'hooks/use-mutation';
import { createSurfaceImageNodeMutation } from 'graphql/surface-node/mutations/surface-image-node/create-surface-image-node';
import { updateSurfaceImageNodeMutation } from 'graphql/surface-node/mutations/surface-image-node/update-surface-image-node';
import { toast } from 'services/toast';
import { pick } from 'lodash';
import { ModalContext } from 'hoc/with-modal';
import { withModal } from 'hoc';

export interface ImageNodeModalProps {
  data: {
    id: string;
    surface: string;
    name: string;
    url?: string;
    format: string;
  };
  modal: ModalContext;
  deleteNode: Function;
}

const defaultProps = {};

function ImageNodeModal(props: ImageNodeModalProps) {
  const { data } = props;
  // @ts-ignore
  const surfaceId = data.surface?.id ?? data.surface;

  const onSurfaceNodeCreate = useOnSurfaceNodeSave('createSurfaceImageNode');

  const onSurfaceNodeUpdate = useOnSurfaceNodeSave('updateSurfaceImageNode');

  const [createSurfaceNode] = useMutation(createSurfaceImageNodeMutation, {
    update: onSurfaceNodeCreate as any,
  });

  const [updateSurfaceNode] = useMutation(updateSurfaceImageNodeMutation, {
    update: onSurfaceNodeUpdate as any,
  });

  function onSubmit(values, { setSubmitting }) {
    const saveOperation = data.id ? updateSurfaceNode : createSurfaceNode;

    const input = data.id
      ? pick(values, ['id', 'name', 'position', 'url', 'format'])
      : values;

    return saveOperation({ variables: { input } }).then((response) => {
      if (response.isFailure) {
        setSubmitting(false);
        toast.error(response.getErrorMessage());

        return response;
      }

      props.modal.hide();

      return response;
    });
  }

  return (
    <ImageNodeForm
      onSubmit={onSubmit}
      initialValues={data}
      onCancel={props.modal.hide}
    />
  );
}

ImageNodeModal.defaultProps = defaultProps;

export default withModal(ImageNodeModal);
